export let UpperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export let LowerCase = 'abcdefghijklmnopqrstuvwxyz';
export let Number = '01234567809';
export let Symbols = '!@#$%^&*()_+'